export const BASE_API_URL =
  'https://up702rkgl1.execute-api.ap-southeast-2.amazonaws.com';
